module.exports = __webpack_public_path__ + "img/1526102708.9f8a4a80.jpg";